import React from 'react'
import { SubscriptionPayment } from '../models/SubscriptionPayment'
import InvoiceTableRow from './InvoiceTableRow';
import { useTranslation } from 'react-i18next';
import ScrollableTable from '../table/ScrollableTable';
import TableHead from '../table/TableHead';
import TableHeadCell from '../table/TableHeadCell';

type Props = {
    payments: SubscriptionPayment[];
}

const InvoiceTable = ({ payments }: Props) => {
    const { t } = useTranslation();
    return (
        <ScrollableTable>
            <TableHead>
                <TableHeadCell>
                    {t("common.date")}
                </TableHeadCell>
                <TableHeadCell>
                    {t("common.description")}
                </TableHeadCell>
                <TableHeadCell align="center">
                    {t("payment.amount")}
                </TableHeadCell>
                <TableHeadCell align="center">
                    {t("payment.invoice")}
                </TableHeadCell>
            </TableHead>
            <tbody>
                {payments.map((payment, i) => (
                    <InvoiceTableRow
                        key={payment.id}
                        payment={payment}
                        index={i}
                    />
                ))}
            </tbody>
        </ScrollableTable>
    )
}

export default InvoiceTable